<div class="alg-tooltip-container {{ styleClass() }}">
  @if (contentTemplate(); as template) {
    <ng-container [ngTemplateOutlet]="template" />
  } @else {
    {{ text() }}
  }
</div>
